import { useQuery } from "@tanstack/react-query";
import { getShiftSchemeAssets } from "../repositories/ShiftRepository";

// Plant owns the fallback scheme; hardcoded 1 as a structural concept.
const PLANT_ASSET_ID = 1;

// Default shift-scheme owner for an asset, mirroring the ancestor walk-up of
// FAB.GetLineSchemeForDate: the asset itself when it has its own scheme
// (e.g. 20th Street Saw, Wax), else its parent area (e.g. weld lines ->
// Welds), else Plant. Calendar day overrides are NOT considered here.
// Returns null until the scheme-owner list loads.
export const useShiftAssetId = (
	assetId: number | null,
	parentAssetId: number | null,
): number | null => {
	const { data: schemeAssets, isError } = useQuery<number[], Error>({
		queryKey: ["shiftSchemeAssets"],
		queryFn: () => getShiftSchemeAssets(),
		staleTime: 5 * 60 * 1000,
	});
	if (!schemeAssets) return isError ? PLANT_ASSET_ID : null;
	if (assetId && schemeAssets.includes(assetId)) return assetId;
	if (parentAssetId && schemeAssets.includes(parentAssetId))
		return parentAssetId;
	return PLANT_ASSET_ID;
};
